import {PROGRESS_STATUSES, UnknownError} from '../../../shared/symbols';
import {UserSharedAccountData} from '../../symbols/dashboard-clinic-patients.symbols';

/** Unique identifier for clinic patients single account state. */
export const clinicPatientsSingleAccountStateUniqueIdentifier = '_clinicPatientsSingleAccount_';

/** Describes clinic patients single account state fields. */
export interface DashboardClinicPatientsSingleAccountStateModel {
  /** Contain load selected scan account progress status. */
  loadSelectedScanAccountStatus: PROGRESS_STATUSES;

  /** Contain related account data to the currently selected scan. */
  selectedScanAccount: UserSharedAccountData;

  /** Contain the last error that occurs during load selected scan account process. */
  lastLoadSelectedScanAccountError: UnknownError;

  /** Contain a load current load patient account progress status. */
  loadPatientStatus: PROGRESS_STATUSES;

  /** Contain last error that occurs during load current manage patient account process. */
  lastLoadPatientError: UnknownError;

  /** Contain load current manage patient account progress status. */
  managePatientStatus: PROGRESS_STATUSES;

  /** Contain last error that occurs during edit patient data process. */
  lastEditPatientError: UnknownError;

  /** Contain related account data to the currently managing patient. */
  currentPatient: UserSharedAccountData;
}

/** Default values for clinic patients single account state initialization and reset. */
export const clinicPatientsSingleAccountStateDefaults: DashboardClinicPatientsSingleAccountStateModel = {
  loadSelectedScanAccountStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  selectedScanAccount: null,
  lastLoadSelectedScanAccountError: null,

  loadPatientStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  lastLoadPatientError: null,
  managePatientStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  lastEditPatientError: null,
  currentPatient: null,
};
